import { ErrorMessage, Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { signUpSchema } from './ValidationSchema';
import axiosInsatnace, { doSignUp, getHeight, getMaritualStatus, getProfileByList } from '../asiosConfig';
import { toast, ToastContainer } from 'react-toastify';
import { } from "react-toastify/ReactToastify.css";
import { useNavigate } from 'react-router-dom';
import { Checkbox, FormControl, FormControlLabel, Grid, IconButton, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, TextField } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../services/firebaseConfig';
import DependentChildrenFields from './DependantChildrenFields';

function SignUpForm() {
    const initialValues = {
        name: '',
        last_name: '',
        email: '',
        password: '',
        day: '',
        month: '',
        year: '',
        maritalStatus: '',
        childrenLivingStatus: '',
        no_of_Children: '',
        height: '',
        mobileNumber: '',
        registerby: '',
        gender: '',
        register_platform: 'Web',
        terms: true
    };
    const [profileByList, setProfileByList] = useState([]);
    const [maritalStatusList, setMaritalStatusList] = useState([]);
    const [height, setHeight] = useState([]);
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchProfileByList = async () => {
            try {
                const response = await getProfileByList();
                setProfileByList(response.data);
            } catch (error) {
                console.error('Error fetching profile by list:', error);
            }
        };

        const fetchMaritalStatusByList = async () => {
            try {
                const response = await getMaritualStatus();
                setMaritalStatusList(response.data);
            } catch (error) {
                console.error('Error fetching marital status:', error);
            }
        }

        const fetchHeightByList = async () => {
            try {
                const response = await getHeight();
                setHeight(response.data);
            } catch (error) {
                console.error('Error fetching Height:', error);
            }
        }
        fetchProfileByList();
        fetchMaritalStatusByList();
        fetchHeightByList();
    }, []);
    const handleSubmit = async (values, { setSubmitting }) => {
        const { name, last_name, email, password, day, month, year, maritalStatus, height, mobileNumber, registerby, gender, terms, register_platform } = values;
        const date_of_birth = `${year}-${month}-${day}`;
        const finalValues = { name, last_name, email, password, maritalStatus, height, mobileNumber, registerby, gender, terms, date_of_birth, register_platform };
        try {
            const response = await doSignUp(finalValues);

            if (response.status === 200 || response.status === 201) {
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('user_id', response.data.user_id);
                localStorage.setItem('user_name', response.data.user_name || '');  // No need to stringify simple strings
                localStorage.setItem('last_complete_step', response.data.last_complete_step || '');
                localStorage.setItem('is_verified', response.data.is_verified);
                localStorage.setItem('mobile_number', response.data.mobile_number);
                localStorage.setItem('gender', response.data.gender);
                localStorage.setItem('account_type', response.data.account_type);

                logEvent(analytics, "sign_up", {
                    method: "Email/Mobile",
                    user_id: response.data.user_id || '',
                    gender: gender,
                    maritalStatus: maritalStatus,
                    platform: 'web',
                })

                navigate('/phone-verification-otp');
                window.location.reload();
            } else {
                const errorMessage = response.data.message || 'Invalid username or password';
                toast.error(errorMessage);
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'An error occurred. Please try again.');
        } finally {
            setSubmitting(false);
        }
    }
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 100 }, (_, i) => currentYear - i).filter(year => year <= currentYear - 18);
    return (
        <div className='formBG'>
            <div className="container">
                <div className="formContent">
                    <h2>REGISTER FREE</h2>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={signUpSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ isSubmitting, values, handleChange }) => (
                            <Form>
                                <Grid container spacing={2}>

                                    <Grid item xs={12} sm={6} md={3}>
                                        <label className='form-label'>Profile Created By</label>
                                        <FormControl fullWidth variant="outlined" margin="none">

                                            <Field
                                                name="registerby"
                                                as={TextField}
                                                select
                                                label="Profile Created By"
                                                size='small'
                                                fullWidth
                                                variant="outlined"
                                                sx={{ backgroundColor: 'white' }}
                                            >
                                                <MenuItem value="">Please Select</MenuItem>
                                                {profileByList.map((profile) => (
                                                    <MenuItem key={profile.id} value={profile.id}>{profile.name}</MenuItem>
                                                ))}
                                            </Field>
                                            <ErrorMessage name="registerby" component="div" className="text-danger" />
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={3}>
                                        <label className='form-label'>First Name</label>
                                        <FormControl fullWidth variant="outlined" margin="none">

                                            <Field
                                                name="name"
                                                as={TextField}
                                                label="First Name"
                                                variant="outlined"
                                                fullWidth
                                                size='small'
                                                sx={{ backgroundColor: 'white' }}
                                            />
                                            <ErrorMessage name="name" component="div" className="text-danger" />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <label className='form-label'>Last Name</label>
                                        <FormControl fullWidth variant="outlined" margin="none">

                                            <Field
                                                name="last_name"
                                                as={TextField}
                                                label="Last Name"
                                                variant="outlined"
                                                fullWidth
                                                size='small'
                                                sx={{ backgroundColor: 'white' }}
                                            />
                                            <ErrorMessage name="last_name" component="div" className="text-danger" />
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={3}>
                                        <label className='form-label' htmlFor="">Email</label>
                                        <FormControl fullWidth variant="outlined" margin="none">

                                            <Field
                                                name="email"
                                                as={TextField}
                                                label="Email"
                                                type="email"
                                                variant="outlined"
                                                size='small'
                                                fullWidth
                                                sx={{ backgroundColor: 'white' }}
                                            />
                                            <ErrorMessage name="email" component="div" className="text-danger" />
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={3}>
                                        <label className='form-label' htmlFor="">Password</label>
                                        <FormControl fullWidth variant="outlined" margin="none">
                                            <Field
                                                name="password"
                                                as={TextField}
                                                type={showPassword ? 'text' : 'password'}
                                                label="Choose Password"
                                                size='small'
                                                variant="outlined"
                                                fullWidth
                                                sx={{ backgroundColor: 'white' }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={() => setShowPassword(!showPassword)}
                                                                edge="end"
                                                            >
                                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                            <ErrorMessage name="password" component="div" className="text-danger" />
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={4} >
                                                <label className='form-label' htmlFor="">DOB</label>

                                                <FormControl fullWidth size='small' variant="outlined" margin="none">
                                                    <Field
                                                        as={TextField}
                                                        select
                                                        name="day"
                                                        label="Day"
                                                        fullWidth
                                                        size='small'
                                                        sx={{ backgroundColor: 'white' }}
                                                    >
                                                        <MenuItem value="">Select Day</MenuItem>
                                                        {Array.from({ length: 31 }, (_, i) => (
                                                            <MenuItem key={i + 1} value={i + 1}>{i + 1}</MenuItem>
                                                        ))}
                                                    </Field>
                                                    <ErrorMessage name='day' component="div" className='text-danger' />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <label className='form-label' htmlFor=""> &nbsp; </label>
                                                <FormControl fullWidth size='small' variant="outlined" margin="none">
                                                    <InputLabel>Month</InputLabel>
                                                    <Field
                                                        as={Select}
                                                        name="month"
                                                        label="Month"
                                                        size='small'
                                                        fullWidth
                                                        sx={{ backgroundColor: 'white' }}
                                                    >
                                                        <MenuItem value="">Select Month</MenuItem>
                                                        {Array.from({ length: 12 }, (_, i) => (
                                                            <MenuItem key={i + 1} value={i + 1}>{new Date(0, i).toLocaleString('default', { month: 'long' })}</MenuItem>
                                                        ))}
                                                    </Field>
                                                    <ErrorMessage name='month' component="div" className='text-danger' />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <label className='form-label' htmlFor=""> &nbsp; </label>
                                                <FormControl fullWidth size='small' variant="outlined" margin="none">
                                                    <Field
                                                        as={TextField}
                                                        select
                                                        name="year"
                                                        label="Year"
                                                        fullWidth
                                                        size='small'
                                                        sx={{ backgroundColor: 'white' }}
                                                    >
                                                        <MenuItem value="">Select Year</MenuItem>
                                                        {years.map((year) => (
                                                            <MenuItem key={year} value={year}>{year}</MenuItem>
                                                        ))}
                                                    </Field>
                                                    <ErrorMessage name='year' component="div" className='text-danger' />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item md={2}>
                                        <label className='form-label'>Height</label>
                                        <FormControl fullWidth size='small' variant="outlined" margin="none">
                                            <Field
                                                as={TextField}
                                                select
                                                name="height"
                                                label="Height"
                                                fullWidth
                                                size='small'
                                                sx={{ backgroundColor: 'white' }}
                                            >
                                                <MenuItem value="">Please Select</MenuItem>
                                                {height.map((item) => (
                                                    <MenuItem key={item.id} value={item.height_id}>{item.height}</MenuItem>
                                                ))}
                                            </Field>
                                            <ErrorMessage name='height' component="div" className='text-danger' />
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={3}>
                                        <label className='form-label' htmlFor="">Gender</label>
                                        <FormControl fullWidth size='small' variant="outlined" margin="none">
                                            <Field
                                                as={TextField}
                                                select
                                                name="gender"
                                                label="Gender"
                                                fullWidth
                                                size='small'
                                                sx={{ backgroundColor: 'white' }}
                                            >
                                                <MenuItem value="">Please Select</MenuItem>
                                                <MenuItem value="M">Male</MenuItem>
                                                <MenuItem value="F">Female</MenuItem>
                                            </Field>
                                            <ErrorMessage name='gender' component="div" className='text-danger' />
                                        </FormControl>
                                    </Grid>
                                    <DependentChildrenFields maritalStatusList={maritalStatusList} />
                                    <Grid item md={4}>
                                        <label className='form-label' htmlFor="mobileNumber">Mobile Number</label>
                                        <FormControl fullWidth variant="outlined" margin="none">
                                            <Field name="mobileNumber">
                                                {({ field, form }) => (
                                                    <TextField
                                                        {...field}
                                                        label="Mobile Number"
                                                        variant="outlined"
                                                        fullWidth
                                                        size='small'
                                                        type="tel"
                                                        inputProps={{
                                                            maxLength: 10,
                                                            inputMode: "numeric",
                                                        }}
                                                        sx={{ backgroundColor: 'white' }}
                                                        onChange={(e) => {
                                                            // Allow only numbers and limit to 10 digits
                                                            const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                                                            form.setFieldValue(field.name, value);
                                                        }}
                                                        error={form.touched.mobileNumber && Boolean(form.errors.mobileNumber)}
                                                        helperText={form.touched.mobileNumber && form.errors.mobileNumber}
                                                    />
                                                )}
                                            </Field>
                                        </FormControl>
                                    </Grid>

                                    <Grid item md={12}>
                                        <FormControl fullWidth margin="none">
                                            <FormControlLabel
                                                control={<Field type="checkbox" as={Checkbox} name="terms" />}
                                                label={
                                                    <span style={{ color: 'rgba(0, 0, 0, 0.6)' }}>
                                                        I have agreed to the{" "}
                                                        <a href="/term-of-uses" target="_blank" rel="noopener noreferrer" style={{ color: 'black', textDecoration: 'none' }} >
                                                            Terms & Conditions
                                                        </a>{" "}
                                                        and have read & understood the{" "}
                                                        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: 'black', textDecoration: 'none' }}>
                                                            Privacy Policy
                                                        </a>.
                                                    </span>
                                                }
                                            />
                                            <ErrorMessage name="terms" component="div" className="text-danger" />
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                                            <button
                                                type="submit"
                                                className="btn btn-primary formBtn"
                                                style={{ width: 'auto' }}
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? 'Joining ....' : 'JOIN NOW'}
                                            </button>
                                        </div>
                                    </Grid>

                                </Grid>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}

export default SignUpForm;
